// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase : {
    apiKey: 'AIzaSyAdTsKA5pk97dsRUc1ePXUXsYrbLAmQSJ8',
    authDomain: 'authapp-f388b.firebaseapp.com',
    databaseURL: 'https://authapp-f388b.firebaseio.com',
    projectId: 'authapp-f388b',
    storageBucket: 'authapp-f388b.appspot.com',
    messagingSenderId: '888720237169'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
